import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { AuthProvider } from './auth/auth-context';
import { ensureCsrfInitialized } from './lib/csrf';
import './index.css';
import { queryClient } from './lib/query-client';
import { CACHE_BUSTER, queryPersister } from './lib/query-persister';
import { registerSW } from 'virtual:pwa-register';

// CSRF-Cookie initialisieren bevor erste mutierende Requests starten
ensureCsrfInitialized();

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('#root nicht gefunden');

createRoot(rootElement).render(
  <StrictMode>
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{
        persister: queryPersister,
        maxAge: 24 * 60 * 60 * 1000,
        buster: CACHE_BUSTER,
      }}
    >
      <AuthProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AuthProvider>
    </PersistQueryClientProvider>
  </StrictMode>,
);

// Service Worker registrieren – vite-plugin-pwa kümmert sich um Updates.
registerSW({ immediate: true });
